// In every file you need this!
import $ from 'jquery';
//attach jquery to dom
window.jQuery = $;
window.$ = $;

$(document).ready(function() {
  
  // TOGGLES FOR NAV
  $(".hamburger").on("click", function() {
    $(this).toggleClass("active");
    $(".main_navigation").toggleClass("active");
  });

  $("li.menu-item-has-children>a").on("click", function() {
    $(this).toggleClass("active");
    $(this).next().toggleClass("active");
  });

  $(".filters_area>span").on("click", function() {
    $(".filters_area").toggleClass("active");
  });

  $(".service_blocks_section .section_inner .service_block").hover(function(){
    var image = $(this).attr("data-image");
    $(".service_blocks_section").css('background', 'url("'+image+'")');
  }, function() {
    $(".service_blocks_section").css("background", "#D84F00");
  });


});